export const DownloadUrl = {
  android: 'https://play.google.com/store/apps/details?id=com.mmc.seer.onnet',
  ios: 'https://apps.apple.com/app/id6455938273',
};

export const vipDownloadUrl = {
  android: 'https://play.google.com/store/apps/details?id=com.seer.vip',
  ios: 'https://apps.apple.com/app/id6742473949',
};
